import { LayerProxy } from "./LayerProxy.js";

export { TileProxy };

class TileProxy extends LayerProxy {
    setZIndex(zIndex) { }
}